import { CheckBox } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import useApi from "_api/index";
import RenderDetailCar from "components/Car/RenderDetailCar";
import RenderFieldsCustomers from "components/Car/RenderFieldsCustomers";
import { PaymentChannelOptions } from "contants/options";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { formatCurrency2Digit, formatDateTime } from "utils/helpers/format";
import * as Yup from "yup";
import Dropzone from "components/Dropzone";
import AlertToast from "components/AlertToast";

const { default: CustomizeDialog } = require("components/Car/CustomizeDialog");

const ModalInterest = ({
  isOpen,
  onClose,
  rowID,
  onSuccess,
  type = "interest",
}) => {
  const [customerImage, setCustomerImage] = useState([]);
  const [carImages, setCarImages] = useState([]);
  const [detailCar, setDetailCar] = useState(null);
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [file_slip, setFileSlip] = useState([]);
  const [error, setError] = useState(null);
  const [total_amount, setTotalAmount] = useState(0);

  const getDataInterest = async () => {
    try {
      const response = await useApi.pawn_car.getDetailPawnCarInterestById(
        rowID
      );
      if (response.success) {
        // Process interest data if needed
        const { data } = response;
        const formattedData = {
          ...data,
          car: {
            ...data.car,
            car_pictures: data.car.pictures || [],
          },
        };
        setDetailCar(formattedData);
        setCustomerImage([data.customer?.customer_image] || []);
        formik.setValues({
          prefix: data.customer?.customer_prefix || "",
          fullName: data.customer?.customer_name || "",
          idCardNumber: data.customer?.customer_idcard || "",
          phoneNumber: data.customer?.customer_phonenumber || "",
          address: data.customer?.customer_address || "",
          nationality: data.customer?.customer_nationality || "ไทย",
        });
      }
    } catch (error) {
      console.error("Error fetching interest data:", error);
    }
  };
  useEffect(() => {
    if (isOpen && rowID) {
      //   fetchData();
      getDataInterest();
    } else {
      setDetailCar(null);
      formik.resetForm();
      setFileSlip([]);
      setTotalAmount(0);
      setCustomerImage([]);
    }
  }, [isOpen, rowID]);

  const generateInitialValues = () => {
    return {
      // ข้อมูลลูกค้า
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",

      //ข้อมูลต่อดอก
      payment_method: "",
      note: "",
      period: [],
      penalty: 0,
    };
  };

  const generateValidationSchema = () => {
    return Yup.object({
      payment_method: Yup.string().required("กรุณาเลือกช่องทางการชำระ"),
    });
  };

  const formik = useFormik({
    initialValues: generateInitialValues(),
    validationSchema: generateValidationSchema(),
    onSubmit: (values) => {
      console.log("Form submitted with values:", values);
      // Handle form submission logic here
      if (file_slip?.length === 0) {
        setError("กรุณาแนบหลักฐานการชำระเงิน");
      } else {
        if (type === "redeem") {
          handleUpdateRedeem(values);
        } else {
          handleUpdateInterest(values);
        }
      }
    },
  });

  const handleUpdateInterest = async (values) => {
    try {
      const totalPayment = Number(total_amount.toFixed(2));

      const dataFormatted = {
        period: values.period?.map((item) => ({
          id: item.id,
          payment_method: values.payment_method,
        })),
        description: values.note,
        slip: file_slip,
        total_payment: totalPayment,
      };

      // console.log("dataFormatted > ", dataFormatted);

      const response = await useApi.pawn_car.updatePawnCarInterest(
        detailCar.order_id,
        dataFormatted
      );
      if (response.success || response.isStatus) {
        onSuccess && onSuccess();
        handleClose();
      }
    } catch (error) {
      console.error("Error updating interest data:", error);
      throw error;
    }
  };

  const handleUpdateRedeem = async (values) => {
    try {
      const totalPayment = Number(
        (
          Number(detailCar?.car?.car_price ?? 0) +
          total_amount +
          Number(values.penalty || 0)
        ).toFixed(2)
      );

      const dataFormatted = {
        penalty: values.penalty,
        total_payment: totalPayment,
        period:
          values.period?.map((item) => ({
            id: item.id,
            payment_method: values.payment_method,
          })) || [],
        payment_method: values.payment_method,
        description: values.note,
        slip: file_slip,
      };

      const response = await useApi.pawn_car.updatePawnCarRedeem(
        detailCar.order_id,
        dataFormatted
      );
      if (response.success || response.isStatus) {
        onSuccess && onSuccess();
        handleClose();
      }
    } catch (error) {
      console.error("Error updating redeem data:", error);
      throw error;
    }
  };

  const handleClose = () => {
    formik.resetForm();
    setFileSlip([]);
    setCustomerImage([]);
    setDetailCar(null);
    setTotalAmount(0);
    onClose();
  };

  useEffect(() => {
    if (formik.values.period) {
      const total = formik.values.period?.reduce((sum, item) => {
        const transaction = detailCar?.pawn_transaction?.find(
          (t) => t.id === item.id
        );
        const price = parseFloat(transaction?.pawn_price_permonth || 0);
        return sum + price;
      }, 0);

      setTotalAmount(total);
    }
  }, [formik.values.period, detailCar]);

  const handleCheckboxChange = (transaction, isChecked) => {
    const periodList = formik.values.period || [];

    if (isChecked) {
      const newPeriods = detailCar.pawn_transaction
        .filter(
          (t) =>
            t.payment_status !== "ชำระเงินแล้ว" && t.month <= transaction.month
        )
        .map((t) => ({ id: t.id }));

      const uniquePeriods = Array.from(
        new Map([...periodList, ...newPeriods].map((p) => [p.id, p])).values()
      );

      formik.setFieldValue("period", uniquePeriods);
    } else {
      const remainingPeriods = [];

      for (const t of detailCar.pawn_transaction.sort(
        (a, b) => a.month - b.month
      )) {
        const isPaid = t.payment_status === "ชำระเงินแล้ว";

        if (isPaid) continue;
        if (t.month < transaction.month) {
          if (periodList.some((p) => p.id === t.id)) {
            remainingPeriods.push({ id: t.id });
          }
        } else if (t.month > transaction.month) {
          const prevMonth = detailCar.pawn_transaction.find(
            (x) => x.month === t.month - 1
          );
          if (
            prevMonth &&
            remainingPeriods.some((p) => p.id === prevMonth.id)
          ) {
            if (periodList.some((p) => p.id === t.id)) {
              remainingPeriods.push({ id: t.id });
            }
          }
        }
      }

      formik.setFieldValue("period", remainingPeriods);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <CustomizeDialog
        open={isOpen}
        // onClose={onClose}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            onClose();
          }
        }}
        title={type === "interest" ? "รายการต่อดอก" : "รายการไถ่ถอน"}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            padding: 2,
            borderRadius: 2,
          },
        }}
        onSave={() => {
          // ถ้าต่อดอกครบหมดแล้ว ห้ามบันทึก
          if (
            type === "interest" &&
            detailCar?.pawn_transaction.every(
              (t) => t.payment_status === "ชำระเงินแล้ว"
            )
          ) {
            setToast({
              open: true,
              message: "ต่อดอกครบหมดแล้ว ไม่สามารถบันทึกได้",
              severity: "error",
            });
          } else {
            formik.handleSubmit();
          }
        }}
      >
        <RenderFieldsCustomers
          formik={formik}
          setCustomerImage={setCustomerImage}
          images={customerImage}
          disabled={true}
        />

        <RenderDetailCar car={detailCar?.car} />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography variant="h5">
            {type === "interest" ? "ต่อดอก" : "ไถ่ถอน"}
          </Typography>
          <Box sx={{ p: 2, borderRadius: 2, border: "1px solid #E0E0E0" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {detailCar &&
                  detailCar.pawn_transaction.map((transaction, index) => {
                    const isPaid =
                      transaction.payment_status.trim() === "ชำระเงินแล้ว";

                    const isChecked =
                      isPaid ||
                      (formik.values.period || []).some(
                        (p) => p.id === transaction.id
                      );

                    return (
                      <Box
                        key={transaction.id}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box display="flex" alignItems="center">
                          <Checkbox
                            checked={isChecked}
                            disabled={isPaid}
                            onChange={(e) =>
                              handleCheckboxChange(
                                transaction,
                                e.target.checked
                              )
                            }
                          />
                          <Typography variant="body1" sx={{ marginRight: 2 }}>
                            เดือนที่ {transaction.month}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {transaction.payment_date
                              ? `วันที่ชำระ: ${formatDateTime(
                                  transaction.payment_date,
                                  false
                                )}`
                              : "ยังไม่ชำระ"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                              ml: 2,
                            }}
                          >
                            สถานะ: {transaction.payment_status}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                              ml: 2,
                            }}
                          >
                            ยอดชำระ:{" "}
                            {formatCurrency2Digit(
                              transaction.pawn_price_permonth
                            )}{" "}
                            บาท/เดือน
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}

                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                  justifyContent={"flex-end"}
                  sx={{
                    width: "100%",
                    mt: 1,
                  }}
                >
                  {type === "redeem" && (
                    <Grid container spacing={2} alignItems={"center"} mb={1}>
                      <Grid item xs={8}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          ค่าปรับ (ถ้ามี)
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <TextField
                          fullWidth
                          type="number"
                          variant="outlined"
                          name="penalty"
                          placeholder="0"
                          value={formik.values.penalty || ""}
                          onChange={formik.handleChange}
                          InputProps={{
                            inputProps: { min: 0 },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              height: "40px",
                            },
                            "& input": { textAlign: "right" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="subtitle1">บาท</Typography>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <Typography
                        variant="subtitle1"
                        sx={{ textAlign: "right" }}
                      >
                        อัตราดอกเบี้ยร้อยละ:
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        variant="subtitle1"
                        sx={{ textAlign: "right" }}
                      >
                        {detailCar?.interest_rate || 0}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1">ต่อปี</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <Typography
                        variant="subtitle1"
                        sx={{ textAlign: "right" }}
                      >
                        คิดเป็นร้อยละ:
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        variant="subtitle1"
                        sx={{ textAlign: "right" }}
                      >
                        {formatCurrency2Digit(detailCar?.interest_rate / 12) ||
                          0}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1">ต่อเดือน</Typography>
                    </Grid>
                  </Grid>
                  {type === "interest" ? (
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          ยอดดอกเบี้ยที่ต้องชำระทั้งหมด:
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right", color: "#00BB9F" }}
                        >
                          {formatCurrency2Digit(total_amount || 0)}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="subtitle1">บาท</Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right" }}
                        >
                          ยอดที่ต้องชำระทั้งหมด:
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: "right", color: "#00BB9F" }}
                        >
                          {formatCurrency2Digit(
                            Number(detailCar?.car?.car_price ?? 0) +
                              total_amount +
                              Number(formik.values.penalty || 0)
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="subtitle1">บาท</Typography>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Box display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "200px", whiteSpace: "nowrap" }}
                  >
                    ช่องทางการชำระ
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={PaymentChannelOptions}
                    getOptionLabel={(option) => option.label}
                    value={
                      PaymentChannelOptions?.find(
                        (opt) => opt?.id === formik.values?.payment_method
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        "payment_method",
                        newValue?.id ?? ""
                      );
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        bgcolor: "white",
                        height: "40px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="payment_method"
                        placeholder="เลือกช่องทางการชำระ"
                        variant="outlined"
                        fullWidth
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.payment_method &&
                          Boolean(formik.errors.payment_method)
                        }
                        helperText={
                          formik.touched.payment_method &&
                          formik.errors.payment_method
                        }
                      />
                    )}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Box display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "200px", whiteSpace: "nowrap" }}
                  >
                    หมายเหตุ
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="note"
                    placeholder="ระบุหมายเหตุ"
                    value={formik.values.note || ""}
                    onChange={formik.handleChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "40px",
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Typography>
                    หลักฐานการชำระเงิน{""}
                    <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                  </Typography>
                  <Dropzone
                    files={file_slip}
                    setFiles={setFileSlip}
                    setError={setError}
                    error={error}
                    maxImages={1}
                    onDelete={() => setFileSlip([])}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </CustomizeDialog>
      <AlertToast
        open={toast.open}
        type={toast.severity}
        message={toast.message}
        onClose={() => setToast({ ...toast, open: false })}
      />
    </form>
  );
};
export default ModalInterest;
